import Styles from './CreateAssessment.module.scss';
import { useState, useContext, useEffect } from 'react';

import { useNavigate, ViewContext, useAPI, useParams } from 'components/lib';
import { QuizForm } from 'components/global/LMS/QuizForm/QuizForm';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

import axios from 'axios';
import FeatherIcon from 'feather-icons-react';

export function CreateAssessment(props) {

    const viewContext = useContext(ViewContext);

    const { assessId } = useParams();
    const { metricId } = useParams();

    const { data, loading } = useAPI(`/api/metrics/assessment/${assessId}`)

    const [contentEditDetails, setContentEditDetails] = useState({
        type: "",
        lectureID: "",
        action: "edit",
        lectureIndex: -1,
        source: "",
        is_random: false,
        uploadDone: false

    })
    
    useEffect(() => {
        if (data) {
            if (data?.questions !== null) {
                setContentEditDetails((prev) => ({
                    ...prev,
                    action: "edit",
                    source: data?.questions.map((question) => ({
                        ...question,
                        uploadDone: question.uploadDone || false // Set uploadDone to false if not present
                    }))
                }));
                document.title = props.t('QualityQuotient.CreateAssessment.editTitle')
            } else {
                setContentEditDetails(prev => ({
                    ...prev,
                    action: "create",
                }));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    const handleQuizUpload = (quizQuestions, isRandom) => {
        const options = {
            method: "PATCH",
            url: `/api/assessment/${assessId}`,
            headers: {
                "accept": "application/json",
                "content-type": 'multipart/form-data'

            },
            data: { questions: quizQuestions, is_random: isRandom ? 1 : 0, },
        };
        axios
            .request(options)
            .then(function (response) {
                viewContext.notification.show(response.data.message, "success")
                window.location.reload();
            })
            .catch((err) => {
                viewContext.handleError(err);
            });
    }

    const navigate = useNavigate();

    return (
        <>
            <AivagamButton
                id='backButton'
                onClick={() => {
                    navigate(`/metrics/${metricId}/edit`)
                }}
                icon
                buttonText={
                    <>
                        <FeatherIcon size="0.9em" icon="arrow-left" />
                        {props.t('QualityQuotient.CreateAssessment.backBtn')}
                    </>
                }
                type="back"
            />
            <div id='ancestorContainer' className={Styles.ancestorContainer}>
                {data?.name && !loading && ["create", "edit"].includes(contentEditDetails.action) ? (
                    <QuizForm
                        contentEditDetails={contentEditDetails}
                        setContentEditDetails={setContentEditDetails}
                        handleQuizUpload={handleQuizUpload}
                        title={`${props.t('QualityQuotient.CreateAssessment.quizForm')} ${data.name}`}
                        enableRandom={true}
                        backButton={true}
                    />
                ) : (
                    <LoadingBackdrop isOpen={true} />
                )}
            </div>
        </>
    );
}